var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_81252)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 12C28 12.3536 27.8596 12.6928 27.6095 12.9428C27.3595 13.1929 27.0203 13.3333 26.6667 13.3333C26.3131 13.3333 25.9739 13.1929 25.7239 12.9428C25.4738 12.6928 25.3334 12.3536 25.3334 12V8.552L20.6174 13.268C22.1558 15.2847 22.8705 17.8107 22.6165 20.3344C22.3626 22.8582 21.159 25.1912 19.2496 26.8609C17.3402 28.5307 14.8676 29.4125 12.3325 29.3277C9.79743 29.2429 7.38928 28.1979 5.59569 26.4044C3.8021 24.6108 2.75711 22.2026 2.67234 19.6675C2.58757 17.1324 3.46933 14.6598 5.13909 12.7504C6.80886 10.841 9.14182 9.63747 11.6656 9.38353C14.1894 9.12958 16.7153 9.84419 18.732 11.3827L23.448 6.66667H20C19.6464 6.66667 19.3073 6.52619 19.0572 6.27614C18.8072 6.02609 18.6667 5.68696 18.6667 5.33333C18.6667 4.97971 18.8072 4.64057 19.0572 4.39052C19.3073 4.14048 19.6464 4 20 4H26.3334C27.2534 4 28 4.74667 28 5.66667V12ZM12.6667 12C10.7218 12 8.85652 12.7726 7.48126 14.1479C6.10599 15.5232 5.33337 17.3884 5.33337 19.3333C5.33337 21.2783 6.10599 23.1435 7.48126 24.5188C8.85652 25.8941 10.7218 26.6667 12.6667 26.6667C14.6116 26.6667 16.4769 25.8941 17.8522 24.5188C19.2274 23.1435 20 21.2783 20 19.3333C20 17.3884 19.2274 15.5232 17.8522 14.1479C16.4769 12.7726 14.6116 12 12.6667 12Z",
    fill: "#2482DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_81252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/male_icon.72dc7121cbeed165007d39f3c7523ba8.svg";
export { ForwardRef as ReactComponent };